export const API_MASTER_URL = 'http://master-suppression.lopsolutions.com/api';